import { AbstractPmsApiService } from "./abstract.service";
import { RatePlan } from "../models";
import moment from 'moment';

/**
 * @class RatePlanPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<RatePlan>}
 */
export class RatePlanPmsApiService extends AbstractPmsApiService {
    
    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        
        return '/property/:propertyId/rate-plan(/:id)';
    }
    
    /**
     * @param {Object.<string, *>} attributes
     * @returns {RatePlan}
     * @protected
     */
    newModel(attributes, ...params) {
        
        return new RatePlan(attributes);
    }
    
    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<RatePlan>>}
     */
    get(params = {}, property = null) {
        
        const url = this.url({
            propertyId: property ? property.id : 0
        });
        
        const ignoreLB = params.hasOwnProperty('searchValue');
        
        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
                ignoreLoadingBar: ignoreLB
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }
    
    /**
     * @param {RatePlan} ratePlan
     * @param {Property} property
     * @returns {Promise.<RatePlan>}
     */
    create(ratePlan, property) {
        
        const url = this.url({
            propertyId: property.id
        });
        
        ratePlan = ratePlan.toObjectExcept('property');
        
        if (ratePlan.intervals) {
            
            for (let model of ratePlan.intervals) {
                
                model.start_date = moment(model.start_date).format('YYYY-MM-DD');
                model.end_date = moment(model.end_date).format('YYYY-MM-DD');
                
                //transform to sync pivot data
                if (angular.isArray(model.property_accommodation_types)) {
                    
                    let roomTypes = {};
                    
                    for (let type of model.property_accommodation_types) {
                        
                        roomTypes[type.id] = type.pivot;
                    }
                    
                    model.property_accommodation_types = roomTypes;
                }
            }
        }
        
        return this.http
            .post(url, ratePlan, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
    
    /**
     * @param {integer} propertyId
     * @param {integer} ratePlanId
     * @param {object} params
     */
    show(propertyId, ratePlanId, params = {}) {
        
        const url = this.url({
            propertyId: propertyId,
            id: ratePlanId
        });
        
      return this.http.get(url, {
            headers: this.authHeaders,
            params
        })
        .then(this.getModeler())
        .catch(this.getErrorHandler());
    }
    
    /**
     * @param {RatePlan} ratePlan
     * @returns {Promise.<RatePlan>}
     */
    update(ratePlan) {
        
        const url = this.url({
            propertyId: ratePlan.property.id,
            id: ratePlan.id
        });
        
        return this.http
            .put(url, ratePlan.toObjectExcept('property'), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
    
    /**
     * @param {RatePlan} ratePlan
     * @returns {Promise.<boolean>}
     */
    delete(ratePlan) {
        
        const url = this.url({
            propertyId: ratePlan.property.id,
            id: ratePlan.id
        });
        
        return this.http
            .delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/rate-plan.service.js